<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <button @click="onBack" class="btn btn bg-utel-v2-secondary text-primary mb-3">
            <strong>
                <i class="fa fa-arrow-left"></i>
                Regresar
            </strong>
        </button>

        <h1 class="edit-title">Editar curso</h1>
        <create-course-step-1 :editing="true" :stepData="courseData.step1Data"
            v-if="courseData.step1Data"></create-course-step-1>

        <div class="mt-4">
            <create-course-step-2
                :editing="true"
                :stepData="courseData.step2Data"
                :eliminaPost="eliminaPost"
                :eliminaSection="eliminaSection"
                :eliminaItem="eliminaItem"
                :eliminaQuizQuestion="eliminaQuizQuestion"
                :eliminaQuestionAnswer="eliminaQuestionAnswer"
                v-if="courseData.step2Data"
            ></create-course-step-2>
        </div>

        <div class="d-flex flex-wrap justify-content-end mt-4 container">
            <button @click="cancel" class="btn mx-3 btn-outline-primary rounded-8 px-5 mx-3">
                Cancelar
            </button>
            <button @click="saveCourse" :disabled="saving || !isValid" class="btn mx-3 btn-primary text-light rounded-8 px-5 mx-3 custombutton">
                {{ saving ? 'Guardando...' : 'Guardar cambios' }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['courseId', 'url_update_course'],
    data() {
        return {
            url: `${this.url_update_course}/${this.courseId}`,
            courseData: {},
            updateCourseUrl: '',
            updateCourseSectionsUrl: '',
            saving: false,
            questionnaireSectionId: '',
            eliminaPost: [],
            eliminaSection: [],
            eliminaItem: [],
            eliminaQuizQuestion: [],
            eliminaQuestionAnswer: [],
        }
    },
    mounted() {
        this.getCourseData();
    },
    computed: {
        isValid(){
            return this.validate();
        }
    },
    methods: {
        getCourseData() {
            axios.get(this.url).then(resp => {
                const { course, urlUpdateCourse, urlUpdateCourseSection, sections } = resp.data;
                this.updateCourseUrl = urlUpdateCourse;
                this.updateCourseSectionsUrl = urlUpdateCourseSection;
                this.formatCourseData(course, sections);
            })
        },
        onBack() {
            this.$emit('onBack');
        },
        validate(){
            const step1Valid = this.validateStep1();
            const step2Valid = this.validateStep2();

            return step1Valid && step2Valid;
        },
        validateStep1(){
            if (!this.courseData.step1Data) return false;

            const { name, description, level } = this.courseData.step1Data;
            return name.trim().length > 0
                    && description.trim().length > 0
                    && level.trim().length > 0;
        },
        validateStep2(){
            const hasInvalidModules = this.courseData.step2Data?.modules?.some(module =>
                (module.name.trim().length < 1 || module.description.trim().length < 1)
            );
            const hasInvalidQuestionnaires = this.courseData.step2Data?.questionnaires?.some(questionnaire => {
                for (const propertyName of ['aprobacion', 'repeticiones', 'duracion','tipoDuracion']) {
                    if (questionnaire[propertyName].trim().length < 1) {
                        return true
                    }
                }

                return false;
            });

            return !hasInvalidModules && !hasInvalidQuestionnaires;
        },
        formatCourseData(course, sections) {
            this.courseData = {
                step1Data: {
                    name: course.nombre_curso || '',
                    description: course.descripcion_del_curso || '',
                    level: course.nivel || 'intermedio',
                    cover: null,
                    ...course
                }
            }
            const modules = this.formatCourseModules(sections);
            const questionnaires = this.formatCourseQuestionnaires(sections);

            this.courseData = {
                ...this.courseData,
                step2Data: {
                    modules,
                    questionnaires
                }
            }
        },
        formatCourseModules(sections){
            return sections.filter(section => section.items.some(item => item.type === 'lp_lesson'))
                .map(section => ({
                    id: Math.random().toString(16).slice(2),
                    name: section.titulo_seccion,
                    description: section.descripcion_seccion,
                    lessons: this.formatModuleLessons(section.items),
                    ...section
                }));
        },
        formatModuleLessons(items){
            return items.map(lesson => ({
                id: Math.random().toString(16).slice(2),
                name: lesson.title,
                durationLength: lesson.duration || '',
                durationType: lesson.durationType || '',
                description: lesson.description,
                ...lesson
            }))
        },
        formatCourseQuestionnaires(sections){
            return sections.filter(section => section.items.some(item => item.type === 'lp_quiz'))
                .flatMap(section => {
                    this.questionnaireSectionId = section.section_id;
                    return section.items.map(item => ({
                        id: Math.random().toString(16).slice(2),
                        aprobacion: item.calificacion_aprobatoria,
                        repeticiones: item.retomar,
                        duracion: item.calificacion_aprobatoria,
                        tipoDuracion: item.tipo_duracion_del_cuestionario,
                        questions: this.formatQuestionnaireQuestions(item.preguntas),
                        ...item
                    }));
                });
        },
        formatQuestionnaireQuestions(questions){
            return questions.map((question, index) => ({
                id: Math.random().toString(16).slice(2),
                question_type: question.type,
                question: question.title,
                description: question.description,
                name: `Pregunta ${index + 1}`,
                answer: question.answer,
                advice: question.advice || '',
                explanation: question.explanation || '',
                ...question,
                answers: question.answers.map(answer => ({
                    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
                    text: answer.option,
                    ...answer
                })),
            }))
        },
        cancel(){
            this.courseData = {};
            this.onBack();
        },
        saveCourse(){
            if(!this.validate()) return;

            this.saving = true;
            const course = this.createCourseObject();
            axios.post(this.updateCourseUrl, course)
            .then(resp => {
                const sections = this.createCourseSectionsObject();
                axios.post(this.updateCourseSectionsUrl, {
                    secciones: sections,
                    elimina_section: this.eliminaSection,
                    elimina_post: this.eliminaPost,
                    elimina_item: this.eliminaItem,
                    elimina_quiz_question : this.eliminaQuizQuestion,
                    elimina_question_answer: this.eliminaQuestionAnswer
                })
                .then(res => {
                    this.saving = false;
                    this.$emit('onSaved');
                })
                .catch(err => console.log(err))
            })
            .catch(err => console.log( err ))
        },
        createCourseObject(){
            const sameFields = ['estado_del_curso', 'cantidad_duracion_del_curso', 'tipo_duracion_del_curso',
                                'maximo_estudiantes','tipo_evaluacion', 'bloquear_finalizar', 'bloquear_duracion', 'lenguajes','resena'];
            const course = {
                nombre_curso: this.courseData.step1Data.name,
                descripcion_del_curso: this.courseData.step1Data.description,
                nivel: this.courseData.step1Data.level,
                aprobacion: parseInt(this.calculateCourseApproval()),
                client_id: this.courseData.step1Data.client_id
            }
            sameFields.forEach(field =>{
                course[field] = this.courseData.step1Data[field]
            });

            return course;
        },
        calculateCourseApproval(){
            const totalApproval = this.courseData.step2Data.questionnaires.reduce((sum, questionnaire) => sum + parseInt(questionnaire.aprobacion), 0);
            return totalApproval / this.courseData.step2Data.questionnaires.length;
        },
        createCourseSectionsObject(){
            const sections = [];
            const { modules = [], questionnaires = [] } = this.courseData.step2Data;
            modules.forEach(module => {
                sections.push(this.handleModuleObject(module));
            });
            sections.push(this.handleQuestionnairesObject(questionnaires))

            return sections;
        },
        handleModuleObject(module){
            return {
                "section_id": module.section_id,
                "titulo_seccion": module.name,
                "descripcion_seccion": module.description,
                "items": module.lessons.map(lesson => ({
                    title: lesson.name,
                    description: lesson.description,
                    type: "lp_lesson",
                    duration: lesson.durationLength,
                    durationType: lesson.durationType,
                    post_id: lesson.post_id,
                    section_item_id: lesson.section_item_id
                }))
            };
        },
        handleQuestionnairesObject(questionnaires){
            return {
                "section_id": this.questionnaireSectionId || "",
                "titulo_seccion": "Cuestionario",
                "descripcion_seccion": "Sección de cuestionarios",
                "items": questionnaires.map(questionnaire => {
                    return {
                        title: "",
                        description: "",
                        type: "lp_quiz",
                        cantidad_duracion_del_cuestionario: questionnaire.duracion,
                        tipo_duracion_del_cuestionario: questionnaire.tipoDuracion,
                        calificacion_aprobatoria: questionnaire.aprobacion,
                        retomar: questionnaire.repeticiones,
                        paginacion: questionnaire.paginacion || 1,
                        revision_inmediata: questionnaire.revision_inmediata || false,
                        resena: questionnaire.resena || true,
                        mostrar_respuesta_correcta: questionnaire.mostrar_respuesta_correcta || true,
                        post_id: questionnaire.post_id,
                        section_item_id: questionnaire.section_item_id,
                        preguntas: questionnaire.questions.map(question => {
                            return {
                                title: question.question,
                                description: question.description,
                                points: question.points || 1,
                                type: question.question_type,
                                quiz_question_id: question.quiz_question_id,
                                answer: question.answer,
                                post_id: question.post_id,
                                answers: question.answers.map(answer => ({
                                    option: answer.text,
                                    type: question.question_type === 'multi_choice' ? 'checkbox' : 'radio',
                                    question_answer_id: answer.question_answer_id
                                }))
                            }
                        })
                    }
                })
            }
        },
    }
}
</script>
<style>
    .edit-title {
        color: #1A0054;
        font-weight: 700;
        font-size: 36px;
    }

    .custombutton:disabled{
        background-color: #BCB7D1 !important;
        color: #6B6876 !important;
        border: none !important;
    }
</style>
